import type { PaymentCancellationResult } from "./PaymentCancellationDrawer";
import { ReminderCreateDrawer } from "./ReminderCreateDrawer";

export type PaymentCancellationReminderRequest = Pick<PaymentCancellationResult, "personId" | "reminderCases">;

/** Dieselbe Mahnfallfolge nach einer Rücklastschrift aus Personenakte und Kontoauszug. */
export function PaymentCancellationReminders({ pending, onChange, onCreated }: {
  pending: PaymentCancellationReminderRequest | null;
  onChange: (pending: PaymentCancellationReminderRequest | null) => void;
  onCreated: () => void;
}) {
  const current = pending?.reminderCases[0];
  if (!pending || !current) return null;

  const advance = () => {
    const remaining = pending.reminderCases.filter(item => item.triggerOpenItemId !== current.triggerOpenItemId);
    onChange(remaining.length > 0 ? { ...pending, reminderCases: remaining } : null);
  };

  return <ReminderCreateDrawer
    key={`${pending.personId}:${current.triggerOpenItemId}`}
    open
    personId={pending.personId}
    triggerOpenItemId={current.triggerOpenItemId}
    initialSelectedOpenItemIds={current.preferredOpenItemIds}
    ignoreReminderDelay
    onCancel={advance}
    onCreated={() => {
      onCreated();
      advance();
    }}
  />;
}
